import React from 'react';
import LoanId from '../Login Methods/Loan Id/Login_With_Loan_ID';
import Email from '../Login Methods/Email/Login_With_Email_ID';
import MobileNo from '../Login Methods/Mobile/Mobile_No';
import logo from '../../Images/logo.png'
import playstore from '../../Images/playstore.png';
import applestore from '../../Images/applestore.jpg'
import qrcode from '../../Images/qr code.png'
import PropTypes from 'prop-types';



const RenderComponent = ({ index, setmobile_number }) => {
  switch (index) {
    case 0: return <MobileNo setmobile_number={setmobile_number} />;
    case 1: return <LoanId />;
    case 2: return <Email />;
    default: return null; 
  }
};



const Customer_Login = ({ setmobile_number }) => {

  return (
    <div className="Container"  >

      <div className='RightContainer' style={{ padding: '0' }}>
        <img src={logo} alt="logo" style={{ width: '40%', display: 'flex' }} />
        {/* <h2 className='indiaselterloginmessage' style={{ fontSize: '20px', textAlign: 'center' }}>Welcome to Customer Portal</h2> */}
        {/* <div style={{ textAlign: 'center', fontSize: '13px' }}>Login To Easily Manage Your Existing Loan & Pay EMI's</div> */}
        <div className='Right_Container' >
          <RenderComponent index={0} setmobile_number={setmobile_number} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '2vh' }}>
          <img src={qrcode} alt="qr code" style={{ width: '28%' }} />
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left', justifyContent: 'left', padding: '2vh' }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', width: '100%', alignItems: 'center' }}>
              <a
                href="https://play.google.com/store/apps/details?id=com.indiasheltercustomerapp&hl=en_IN"
                target="_blank"
                rel="noopener noreferrer"
                style={{ width: '30%', height: '80%', cursor: 'pointer' }}
              >
                <img src={playstore} alt="playstore" style={{ width: '100%', height: '100%' }} />
              </a>
              <a
                href="https://apps.apple.com/in/app/indiashelter-iserve/id6511235049"
                target="_blank"
                rel="noopener noreferrer"
                style={{  width: '30%', height: '72%', marginLeft:'.3vh', cursor: 'pointer' }}
              >
                <img src={applestore} alt="appstore" style={{ width: '100%' }} />
              </a>
            </div>
            <h5 style={{ fontSize: '12px', textAlign: 'left' }}>Download our app for a personalised experience</h5>
          </div>
        </div>
      </div>
    </div>
  )

}

// PropTypes validation
Customer_Login.propTypes = {
  setmobile_number: PropTypes.string,
};

// Prop validation
RenderComponent.propTypes = {
  index: PropTypes.number.isRequired,
  setmobile_number: PropTypes.func,
};

export default Customer_Login;
